<template>
    <div class="home-public">

        <div class="banner">
            <img src="/images/portland-banner.jpg" alt="The Yard Logo">
            <div class="home-top">
                <div class="home-top__mission">
                    <div class="home-mission flex-column">
                        <h2>Our Mission</h2>
                        <p>Clean Air Construction is a regional collaboration between the City of Portland, Metro,
                            Multnomah County, Port of Portland, TriMet, and Washington County to reduce diesel
                            particulate matter emissions on our construction projects. <strong>The Yard</strong>
                            software is a
                            valuable tool to manage the emissions compliance of equipment/vehicles used on partner
                            agency construction projects.</p>
                        <p class="underline-link--black"><a href="https://portland.gov/cac">View more info at Portland.Gov &raquo;</a></p>
                    </div>
                </div>

                <div class="home-top__login">
                    <div class="home-login user-login-form-wrapper">

                        <template v-if="!twofa">

                            <user-login-form/>

                            <div class="forgot-password underline-link--black mt-3">
                                <router-link to="/user/reset">
                                    Forgot password
                                </router-link>
                                <helper tag="login-forgot"/>
                            </div>

                            <div class="forgot-password underline-link--black mt-3">
                                <router-link to="/user/create">
                                    Create Equipment Owner Account
                                </router-link>
                                <helper tag="login-equipment-owner"/>
                            </div>
                        </template>
                        <template v-else>
                            <user-twofa-form/>
                        </template>

                    </div>
                </div>
            </div>
        </div>

        <b-row class="home-public__map">
            <b-col cols="12">
                <map-public></map-public>
            </b-col>
        </b-row>

        <b-row class="mt-3">
            <b-col>
                <h2 class="mb-0 text-center">Participating Agencies</h2>
                <div class="partner-logos d-flex justify-content-center">
                    <img src="/images/Metro_logo_standard-Black.png" alt="Metro logo">
                    <img src="/images/multnomah_county_logo.png" alt="Multnomah logo">
                    <img src="/images/City_of_Portland-logo.png" alt="City of Portland logo">
                    <img src="/images/WashCo-logo.png" alt="Washington County logo">
                    <img src="/images/Port-of-Portland-logo.png" alt="Port of Portland logo">
                    <img src="/images/Trimet-logo.png" alt="TRIMET logo">
                    <img src="/images/PortlandComunityCollege-logo.png" alt="Portland Commmunity College logo">
                </div>
            </b-col>
        </b-row>

    </div>

</template>

<script>

import Vue from 'vue'

/**
 * Home page for non-logged-in users
 */
export default Vue.extend({
    name: 'HomePublic',
    props: {
        twofa: Boolean,
    },
})

</script>

<style lang="scss">

@import '../../sass/variables_mixins';

@media (min-width: 430px) {
    .home-public {
        //margin-left: -15px;
        //margin-right: -15px;
    }
}

.banner {
  position: relative;

  @media(min-width: 768px) {
    box-shadow: 0 0 30px rgba(0,0,0,.25);
    margin-left:-15px;
    margin-right:-15px;
  }

    img {
        display: none;
        @media(min-width: 768px) {
            display: block;
            min-height: 460px;
            width:100%;
            max-width: 200%;
            border-bottom: solid 3px var(--black);
        }
        @media(min-width: 1440px) {
            height: auto;
            max-width: 100%;
        }
    }
}

.home-top {
  @media (max-width: 767px) {
    max-width: 600px;
    margin: 0 auto;
    > div {
      width:100%;
      max-width: 400px;
      margin: 0 auto;
    }
    a {
      font-size: 18px;
    }
  }
  @media (min-width: 768px) {
    @include absolute-center;
    width: 90%;
    display: flex;
    justify-content: space-between;
    max-width: 800px;
  }
}

.home-top__mission {
  background-color: var(--light-blue);
  border-radius: 12px;
  @media(min-width: 768px) {
    width:49%;
    background-color: var(--light-blue-transparent-95);
    @include box-shadow(0 0 30px rgba(0, 0, 0, .2));
  }
  @media(min-width: 1200px) {
    width:56%;
  }
}

.home-mission {
    padding: 2em;

    @media (max-width: 767px) {
        margin: 1em auto 1em auto;
    }

    @media (min-width: 1200px) {
        height:334px;
    }

    p:last-child {
        margin-bottom: 0;
    }
}

.home-top__login {
  border-radius: 12px;
  background-color: var(--yellow);
    @media(min-width: 768px) {
        width:49%;
      background-color: var(--yellow-transparent-90);
      @include box-shadow(0 0 30px rgba(0, 0, 0, .2));
    }
    @media(min-width: 1200px) {
        width:42%;
    }
}

@media(min-width: 1200px) {
  .home-login {
    height: 334px;
  }
}

.user-login-form-wrapper {
    position: relative;
    z-index: 1;
    padding: 2em;

    @media(min-width: 768px) {
        padding: 3em 2em;
        legend {
            max-width: 80px;
            text-align: right;
        }
    }

    input {
        border: none !important;
    }

    legend {
        font-weight: bold;
    }

    .btn-primary {
        opacity: 1 !important;
        color: #fff;
    }
}

.forgot-password {
    text-align: right;

    a {
        display: inline-block;
        position: relative;
    }

    a:hover {
        color: var(--black);
        text-decoration: none;
    }
}

.home-public__map {

  > div {
    //padding-left:0;
    //padding-right:0;
    max-width:1100px;
    margin:auto;
  }
}
@media (max-width:767px) {
  .vue-map-container {
    padding-top:100%!important;
  }
}


.partner-logos {
    padding: 1rem 0 2rem 0;
    flex-wrap: wrap;

    @media (max-width:767px) {
      margin:auto;
      max-width:280px;
    }

    img {
        display: block;

        margin: 10px 10px;
        //max-width: 320px;
        width: auto;
        max-width: 260px;
        max-height: 120px;
        border: solid 1px #ddd;
        padding: 12px;
        background-color: #fff;
    }

    @media (min-width: 768px) {
        img {
            height: 54px;
            max-width: 100%;
            margin: 10px 20px;
        }
    }

    @media (min-width: 1440px) {
        flex-wrap: nowrap;
        img {
            margin: 0 10px;
            height: 68px;
            border: solid 1px #ddd;
            padding: 12px;
            background-color: #fff;
        }
    }
}

</style>
